/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_New_BtnInputs */



/**
* | output |
* | --- |
* | "New League" |
*
* @param {League_New_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_new_btn = /** @type {((inputs?: League_New_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_New_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle Ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva Liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nova Liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo Campionato")
	return /** @type {LocalizedString} */ ("New League")
});